class QuoteFileInput extends HTMLElement {
  constructor() {
    super();
    const input = this.querySelector('.quote-request__upload-input');
    const list = this.querySelector('.quote-request__file-list');
    if (!input || !list) return;

    input.addEventListener('change', () => {
      list.innerHTML = '';
      Array.from(input.files || []).forEach((file) => {
        const item = document.createElement('li');
        item.textContent = file.name;
        list.appendChild(item);
      });
    });
  }
}

customElements.define('quote-file-input', QuoteFileInput);
